/* global axios */
import ApiClient from './ApiClient';

class ResellerApplicationAPI extends ApiClient {
  constructor() {
    super('reseller_application', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  apply({ partnerType, message }) {
    return axios.post(this.url, {
      partner_type: partnerType,
      message,
    });
  }
}

export default new ResellerApplicationAPI();
